import { createFileRoute, redirect } from '@tanstack/react-router';
import { SubscribePage } from '@/components/billing';

export const Route = createFileRoute('/subscribe/')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.user) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
  component: SubscribeRoute,
});

function SubscribeRoute() {
  return <SubscribePage />;
}
